import React from 'react';
import './ButtonGroup.css';

interface ButtonGroupProps {
    options: string[];
    value: string;
    onChange: (value: string) => void;
    className?: string;
    style?: React.CSSProperties;
}

const ButtonGroup: React.FC<ButtonGroupProps> = ({
    options,
    value,
    onChange,
    className,
    style
}) => {
    const handleButtonClick = (optionValue: string) => {
        console.log('ButtonGroup: Button clicked:', optionValue);
        console.log('ButtonGroup: Current value:', value);
        onChange(optionValue);
    };

    const buttonGroupClass = `button-group ${className || ''}`.trim();

    return (
        <div className={buttonGroupClass} style={style}>
            {options.map((option, index) => {
                const isActive = value === option;
                const isFirst = index === 0;
                const isLast = index === options.length - 1;
                
                console.log(`ButtonGroup: Option "${option}" - isActive: ${isActive}`);
                
                let buttonClass = 'button-group-button';
                if (isActive) {
                    buttonClass += ' button-group-button-active';
                } else {
                    buttonClass += ' button-group-button-inactive';
                }
                if (isFirst) {
                    buttonClass += ' button-group-button-first';
                }
                if (isLast) {
                    buttonClass += ' button-group-button-last';
                }

                return (
                    <button
                        type="button"
                        key={option}
                        className={buttonClass}
                        onClick={() => handleButtonClick(option)}
                    >
                        {option}
                    </button>
                );
            })}
        </div>
    );
};

export default ButtonGroup;
